export const TOGGLE_MODAL = 'TOGGLE_MODAL';

export function toggleModal() {
  return {
    type: TOGGLE_MODAL,
  };
}
